import React, { useMemo } from 'react';
import { useTranslation } from 'utils/i18n';
import LegalLayout from 'components/legal/LegalLayout';
import { mapImpressumToSections } from 'utils/legal/sections';

const Impressum = () => {
  const { t, language } = useTranslation();

  // Re-compute sections when language changes
  const sections = useMemo(() => mapImpressumToSections(t), [language]);
  const title = t('title', 'impressum') || 'Impressum';
  const lastUpdated = t('lastUpdated', 'impressum') || '';

  return <LegalLayout title={title} lastUpdated={lastUpdated} sections={sections} />;
};

export default Impressum;

